import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

export const ThemeToggle = () => {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Prevent hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <button
        className="h-9 w-9 flex items-center justify-center text-gray-500 dark:text-gray-300 rounded-lg dark:bg-[#2C3241]"
        aria-label="Przełącz motyw"
        disabled
      >
        <Moon className="h-5 w-5" />
      </button>
    );
  }

  const isDark = resolvedTheme === 'dark';

  const toggleTheme = () => {
    if (theme === 'light') {
      setTheme('dark');
    } else if (theme === 'dark') {
      setTheme('light');
    } else {
      // If system, toggle to opposite of current resolved theme
      setTheme(isDark ? 'light' : 'dark');
    }
  };

  return (
    <button
      onClick={toggleTheme}
      className={cn(
        "h-9 w-9 flex items-center justify-center",
        "text-gray-500 dark:text-gray-300",
        "hover:text-gray-700 dark:hover:text-gray-100",
        "transition-all duration-200",
        "rounded-lg border border-border/50",
        "hover:border-border hover:bg-accent",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "dark:border-primary/30 dark:hover:border-primary/50"
      )}
      aria-label={isDark ? 'Przełącz na tryb jasny' : 'Przełącz na tryb ciemny'}
    >
      {isDark ? (
        <Sun className="h-5 w-5" />
      ) : (
        <Moon className="h-5 w-5" />
      )}
    </button>
  );
};
